module.exports = __webpack_public_path__ + "static/img/02.ef07d11.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/placestogo/06/02.jpg
// module id = OCbT
// module chunks = 0